import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './ListingServicesHeader.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM, getDictionaryItem } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from '../Listing/Filters';
import AutocompleteField from '../Listing/AutocompleteField';
import getListing from '../../utils/getListing';
import { getAlgoliaTagsList, convertQueryParamsToFacets } from '../Listing';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
var ListingServicesHeader = function ListingServicesHeader(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var currentLang = get(sitecoreContext, 'language');
  var dictionary = get(fields, 'data.dictionary');
  var day = getDictionaryItem(dictionary, 'Day') || 'day';
  var days = getDictionaryItem(dictionary, 'Days') || 'days';
  var showLabel = getDictionaryItem(dictionary, 'Show') || 'show';
  var resultsLabel = getDictionaryItem(dictionary, 'Results') || 'results';
  var clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'ClearAll';
  var Cancel = getDictionaryItem(dictionary, 'Cancel') || 'Cancel';
  var FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'Filters';
  var Or = getDictionaryItem(dictionary, 'Or') || 'Or';
  var SearchPlaceholder = getDictionaryItem(dictionary, 'search by keyword') || 'search by keyword';
  var SelectService = getDictionaryItem(dictionary, 'selected services') || 'select services';
  var ServiceFilter = getDictionaryItem(dictionary, 'services filter description') || 'services filter description';
  var filterValue = get(fields, 'data.listingConfiguration.filters.values') || [];
  var filterData = get(fields, 'data.listingConfiguration.filters', {});
  var resultDropdownSetting = {
    "name": "Service Tags",
    "title": {
      "jss": {
        "value": ServiceFilter
      }
    },
    "fieldNameItem": {
      "item": {
        "fieldName": {
          "value": ServiceFilter
        }
      }
    },
    "fieldTypeItem": {
      "item": {
        "fieldType": {
          "value": "Dropdown result"
        }
      }
    }
  };
  var filterDataConcat = _objectSpread(_objectSpread({}, filterData), {}, {
    values: [].concat(_toConsumableArray(filterData.values), [resultDropdownSetting])
  });
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    resetFilter = _React$useState2[0],
    setResetFilter = _React$useState2[1];
  var _React$useState3 = React.useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    facets = _React$useState4[0],
    setFacets = _React$useState4[1];
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    defaultFacets = _React$useState6[0],
    setdefaultFacets = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    nbHits = _React$useState8[0],
    setNbHits = _React$useState8[1];
  var _React$useState9 = React.useState([]),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    hits = _React$useState10[0],
    setHits = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    queryHits = _React$useState12[0],
    setQueryHits = _React$useState12[1];
  var _React$useState13 = React.useState(0),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    page = _React$useState14[0],
    setpage = _React$useState14[1];
  var indexes = get(params, 'SearchIndex');
  var typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  var facetFilters = convertQueryParamsToFacets(queryParams, true, filterData);
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    firstRendering = _React$useState16[0],
    setFirstRendering = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    setFilters = _React$useState18[0],
    applySetFilters = _React$useState18[1];
  var _React$useState19 = React.useState(),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    result = _React$useState20[0],
    setResult = _React$useState20[1];
  var _React$useState21 = React.useState([]),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    currentTypes = _React$useState22[0],
    applycurrentTypes = _React$useState22[1];
  var pageSize = get(fields, 'data.listingConfiguration.pageSize.jss.value') || 10;
  var defaultInfoTitle = get(fields, 'data.item.pageTitle.jss.value');
  var helperText = get(fields, 'data.item.pageIntro.jss.value');
  var smallTitle = get(fields, 'data.item.smallTitle.jss.value');
  var _React$useState23 = React.useState('theme-1'),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    themeName = _React$useState24[0],
    setThemeName = _React$useState24[1];
  React.useEffect(function () {
    var facetNames = [];
    var tag = 'tags:';
    if (canUseDOM) {
      var hash = window.location.hash;
      var hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    var types = typeArray.map(function (type) {
      var value = type && type.value;
      // if (value === 'Single Day Itinerary') value = 'Single Day Itinerary Page';
      // if (value === 'Multiple Days Itinerary') value = 'Multiple Days Itinerary Page';

      return "type:".concat(value);
    });
    applycurrentTypes(types);
    if (filterData) {
      facetNames = filterData.values.map(function (filter) {
        return get(filter, 'fieldNameItem.item.fieldName.value');
      });
    }
    var filters;
    if (queryParams.datesRange) {
      filters = queryParams.datesRange.split('+').join(' ');
    } else {
      var filterValues = getAlgoliaTagsList(filterData);
      if (filterValues.indexOf('datesRange') > -1) {
        filters = "datesRange.to > ".concat(Date.parse(new Date()) / 1000);
      }
      if (~filterValues.indexOf('universityPrograms.programs.anualFee') && queryParams['universityPrograms.programs.anualFee']) {
        filters = "".concat(queryParams['universityPrograms.programs.anualFee']).split('+').join(' ');
        filters = filters.replace('anualFee', 'annualFee').replace('anualFee', 'annualFee');
      }
    }
    if (queryParams.valid) {
      filters = queryParams.valid.split('+').join(' ');
    }
    var isLoadedFeatureItem = firstRendering && types.length == 1 && types[0] == "type:Event";
    var itemFilters = {
      filters: filters,
      facets: _toConsumableArray(facetNames),
      facetFilters: [_toConsumableArray(types)].concat(_toConsumableArray(facetFilters), [[tag]]),
      hitsPerPage: pageSize,
      page: page
    };
    // if(facetFilters.length !== 0){
    //  lastQuery = facetFilters[facetFilters.length -1][0].split(':')[0]
    // // facetFilters && facetFilters[0] && facetFilters[0][0].split(':')[0]
    // }

    getListing(indexes, itemFilters).then(function (response) {
      setFacets(response.facets);
      setResult(response);
      applySetFilters(false);
      setNbHits(response.nbHits);
      if (response.hits.length) {
        setHits(hits.concat(response.hits[0].featured && isLoadedFeatureItem && response.nbPages > 1 ? response.hits.splice(0, response.hits.length - 1) : response.hits));
      }
      setTimeout(function () {
        if (canUseDOM) {
          window.onscroll = function () {};
        }
      }, 100);
      setFirstRendering(false);
    });
  }, [resetFilter, setFilters, page]);
  var getValues = function getValues(querySearch) {
    getListing(indexes, {}, {
      query: querySearch,
      hitsPerPage: pageSize
    }).then(function (response) {
      setQueryHits(response.hits);
    });
  };
  React.useEffect(function () {
    var facetNames = [];
    var tag = 'tags:';
    if (canUseDOM) {
      var hash = window.location.hash;
      var hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setThemeName('theme-27');
    }
    var types = typeArray.map(function (type) {
      var value = type && type.value;
      // value
      // if (value === 'Single Day Itinerary') value = 'Single Day Itinerary Page';
      // if (value === 'Multiple Days Itinerary') value = 'Multiple Days Itinerary Page';

      return "type:".concat(value == 'Service' ? '' : value);
    });
    if (filterData) {
      facetNames = filterData.values.map(function (filter) {
        return get(filter, 'fieldNameItem.item.fieldName.value');
      });
    }
    var itemFilters = {
      facets: _toConsumableArray(facetNames),
      facetFilters: [_toConsumableArray(types), [tag]],
      hitsPerPage: pageSize,
      page: page
    };
    getListing(indexes, itemFilters).then(function (response) {
      setdefaultFacets(response.facets);
      setQueryHits(response.hits);
    });
  }, []);
  var setFilter = function setFilter(filtersRecived) {
    getValues(filtersRecived);
  };
  var setListingFilter = function setListingFilter(filtersRecived) {
    setpage(0);
    setHits([]);
    applySetFilters(true);
    setdefaultFacets(result && result.facets);
  };
  var resetFilterCallback = function resetFilterCallback() {
    setFacets(undefined);
    setResult(undefined);
    // setNbHits(0);
    // setNbHits2(0);
    setHits([]);
    setpage(0);
    setResetFilter(true);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "services-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "services-header__holder ".concat(themeName)
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-topbot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 offset-md-1"
  }, !!defaultInfoTitle && /*#__PURE__*/React.createElement("h1", {
    className: "h2 hs__title"
  }, defaultInfoTitle), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(AutocompleteField, {
    setFilter: setFilter,
    facetsName: 'Test',
    clearAlllFilters: false,
    hits: queryHits,
    placeholder: SearchPlaceholder
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "services-header__subText"
  }, /*#__PURE__*/React.createElement("span", null, Or)))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "services-header__filterDesc"
  }, SelectService), filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    fields: filterDataConcat,
    facets: facets,
    defaultFacets: defaultFacets,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    day: day,
    days: days,
    Cancel: Cancel,
    FiltersCopy: FiltersCopy,
    isTagPage: false,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    firstQuery: '',
    analytics: {},
    imageDictionary: {},
    fullWidth: true,
    showClearAll: false,
    apllyFiltersOnChange: true,
    resetAllFiltersCallback: function resetAllFiltersCallback() {}
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: "services-header__description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-9 offset-md-1"
  }, !!smallTitle && /*#__PURE__*/React.createElement("h2", {
    className: "h3 hs__title"
  }, smallTitle), /*#__PURE__*/React.createElement("p", {
    className: "desk__desc"
  }, helperText))))));
};
var commonStyles = "cy008i5";
var rtlStyles = "r1fmwvrq";
var ltrStyles = "l13a3spn";
var commonoFocusEvent = "c56y12";
var ColorsLogic = "c2i1zhz";
var globalStyles = "g1nwmec2";
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(globalStyles, " ").concat(commonoFocusEvent, " ").concat(ColorsLogic),
    removePaddingMobile: true
  }, children);
};
export default ListingServicesHeader;